export default __webpack_public_path__ + "static/media/profile-avatar.88333bc5.png";